import { render, staticRenderFns } from "./RecipeDeleteModal.vue?vue&type=template&id=cf84d19c&scoped=true"
import script from "./RecipeDeleteModal.vue?vue&type=script&lang=js"
export * from "./RecipeDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./RecipeDeleteModal.vue?vue&type=style&index=0&id=cf84d19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf84d19c",
  null
  
)

export default component.exports